import { SplitDirection } from "./index185.js";
function getSubdivisionRatio(ratio, direction = SplitDirection.transverse) {
  const minFactor = Math.min(ratio, 1 - ratio);
  const maxFactor = 1 - minFactor;
  return { ratio, minFactor, maxFactor, direction };
}
export {
  getSubdivisionRatio
};
//# sourceMappingURL=index230.js.map
